/**
 * Copyright 2020 (c) Dominik Basner, Sotec GmbH (for VDW e.V.)
 * Copyright 2020 (c) Fabian Wilhelm, Sotec GmbH (for VDW e.V.)
 * Copyright 2020-2021 (c) Christian von Arnim, ISW University of Stuttgart (for umati and VDW e.V.)
 * Copyright 2021 (c) Moritz Walker, ISW University of Stuttgart (for umati and VDW e.V.)
 * Copyright 2023 (c) Karsten Röthig, FVA GmbH (for umati and VDW e.V.)
 */
import { labels } from '@umati/dashboard-common';
import { IMachine } from '@umati/dashboard-types';
import classNames from 'classnames';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { setMachineFavourite, setMachineFavouriteType } from 'redux/actions';
import FrontendURLs from 'utilities/FrontendURLs';
import MachineHandling from 'utilities/MachineHandling';
import TemplateHelper from 'utilities/TemplateHelper';
import StatusTimeline from '../timeline/StatusTimeline';

const ConditionalWrapper = ({ condition, wrapperCond, wrapperNotCond, children }) =>
  condition ? wrapperCond(children) : wrapperNotCond(children);

function Location (props) {
  const machine = props.machine;
  const fairTag = props.fairTag;
  if (fairTag && machine.Positions?.[fairTag]) {
    return <span>{machine.Positions?.[fairTag]?.hall} {machine.Positions?.[fairTag]?.booth}</span>;
  } else if (machine.Positions?.offsiteClean) {
    return <span>{machine.Positions.offsiteClean.lat}, {machine.Positions.offsiteClean.lng}</span>;
  } else {
    return <span>{labels.noPosition}</span>;
  }
}

interface IMachineListElementProps {
  machine : IMachine;
  fairTag : string;
  hideOnline? : boolean;
  hideFav? : boolean;
  cb? : {
    expand: () => void;
  },
  in? : boolean;
}

interface IMachineListElementPropsEx {
  setMachineFavourite : setMachineFavouriteType;
}

interface IMachineListElementPropsFull extends IMachineListElementProps, IMachineListElementPropsEx {

}

class MachineListElement extends Component<IMachineListElementPropsFull> {
  handeExpand = (e) => {
    e.stopPropagation();
    this.props.cb?.expand();
  };

  handleLink = (e) => {
    e.stopPropagation();
  };

  render () {
    const machineIdentification = this.props.machine.Data;
    /// \todo replace by machineName (this includes scroll logic in machineList)
    let id = typeof machineIdentification.Model === 'object' && machineIdentification.Model !== null ? String(machineIdentification.Model.text) : String(machineIdentification.Model);
    id = (id.replace) ? id.replace(/\s+/g, '') : '';
    const machineName = MachineHandling.getMachineName(this.props.machine);
    const fairTag = this.props.fairTag;
    const linkTarget = FrontendURLs.getMachine(this.props.machine, fairTag);
    const machine = this.props.machine;
    const template = TemplateHelper.getTemplateByTypeId(machine.TypeDefinition);
    return (
      <li className="list-group-item">
        <ConditionalWrapper wrapperNotCond={children => <Link to={linkTarget} className="list-group-item-link">{children}</Link>}
          wrapperCond={children => <div onClick={this.handeExpand} className="list-group-item-link">{children}</div>}
          condition={this.props.cb}>
          <div className="row align-items-center" id={id}>
            <div className="col">
              {/* toggle "online" class to change status */}
              {!this.props.hideOnline && <span className={classNames('icon-connection', { online: this.props.machine.Online })} title={labels.connectionInfo} />}
              <h4><object><Link onClick={e => e.stopPropagation()} to={linkTarget}>{machineName}</Link></object></h4>
              <div className="row list-group-item-data">
                <div className="col-12 col-sm-6">
                  <b>{labels.manufacturer}</b> {machineIdentification.Manufacturer?.text}
                </div>
                <div className="col-12 col-sm-6">
                  <b>{labels.location}</b>
                  <Location machine={machine} fairTag={fairTag} />
                </div>
              </div>
            </div>
            {!this.props.hideFav &&
              <div className="col-auto">
                {/* toggle "active" class to change status */}
                <button
                  className={classNames('btn-favorite', { active: machine.Favorite })}
                  value={0}
                  title={labels.markAsFavorite}
                  onClick={() => this.props.setMachineFavourite(machine.MachineId, !machine.Favorite)}
                />
              </div>
            }
          </div>
        </ConditionalWrapper>
        {
          this.props.in &&
          <div className="list-group-item-timeline">
            <StatusTimeline namespaceUri={machine.MachineId}
              colorMap={template ? TemplateHelper.getTimelineColorMap(template.timeline) : undefined}/>
          </div>
        }
      </li>
    );
  }
}

export default connect(null, { setMachineFavourite })(MachineListElement);
